import { render } from "./PluginsList.vue?vue&type=template&id=cbe70e22&scoped=true"
import script from "./PluginsList.vue?vue&type=script&lang=js"
export * from "./PluginsList.vue?vue&type=script&lang=js"

import "./PluginsList.vue?vue&type=style&index=0&id=cbe70e22&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1d9c808fc766473613eb0f9d559345b4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbe70e22"]])

export default __exports__